import { RegisterForm } from '../../features/users/authenticate/components/RegisterForm';
import { Hero, HeroTitle } from 'common/components/Hero';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-tailwind/react';

export const RegisterScreen = () => {

    const { t } = useTranslation();

    return (
        <Hero>
            <HeroTitle>{t("Register")}</HeroTitle>

            <RegisterForm />

            <Typography
                key="home"
                as="a"
                href="/signin"
                variant="small"
                color="gray"
                className=""
                placeholder={undefined} 
                onPointerEnterCapture={()=>{}} 
                onPointerLeaveCapture={()=>{}}
            >
                {t("I already have an account")}
            </Typography>
        </Hero>
    );
};

export default RegisterScreen;
